export enum TcsApplicable {
    Yes = "Yes",
    No = "No",
   
}